import { createWebSocketStore } from 'src/components/#services/helpers';
import { isLoggedIn } from 'src/services/auth';
export const getMyEthWallet = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'wallet_get',
        agent: 'evm-adapter',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const checkMetamaskNft = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'nftContract_checkNft',
        agent: 'evm-adapter',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
isLoggedIn.subscribe(() => {
    getMyEthWallet.reset();
});
